import React, { useEffect } from 'react';
import { Button, TextField, MenuItem } from '@mui/material';
import { Formik, Form, FormikHelpers } from 'formik';
import * as Yup from 'yup';
import { TranslationValueReq } from '../types/language';

const schema = Yup.object().shape({
  translationId: Yup.number().required('Translation key is required'),
  languageId: Yup.number().required('Language is required'),
  translatedValue: Yup.string().required('Value is required'),
});

interface Props {
  initialValues: TranslationValueReq;
  onSubmit: (values: TranslationValueReq) => void;
  languages: { id: number; name: string }[];
  translationKeys: { id: number; translationKey: string }[];
}

export const TranslationValueForm: React.FC<Props> = ({
  initialValues,
  onSubmit,
  languages,
  translationKeys,
}) => {
  // Eğer languages ve translationKeys sonradan geliyorsa form resetlenmeli
  const [formKey, setFormKey] = React.useState(0);

  useEffect(() => {
    setFormKey((prev) => prev + 1);
  }, [languages.length, translationKeys.length]);

  return (
    <Formik
      key={formKey} // yeniden oluşturmak için
      initialValues={initialValues}
      validationSchema={schema}
      onSubmit={(
        values: TranslationValueReq,
        { resetForm }: FormikHelpers<TranslationValueReq>
      ) => {
        onSubmit(values);
        resetForm();
      }}
    >
      {({ values, handleChange, handleBlur, touched, errors }) => (
        <Form>
          <TextField
            select
            name="languageId"
            label="Language"
            value={values.languageId}
            onChange={handleChange}
            onBlur={handleBlur}
            fullWidth
            error={touched.languageId && Boolean(errors.languageId)}
            helperText={touched.languageId && errors.languageId}
            sx={{ mt: 2 }}
          >
            {languages.map((lang) => (
              <MenuItem key={lang.id} value={lang.id}>
                {lang.name}
              </MenuItem>
            ))}
          </TextField>

          <TextField
            select
            name="translationId"
            label="Translation Key"
            value={values.translationId}
            onChange={handleChange}
            onBlur={handleBlur}
            fullWidth
            error={touched.translationId && Boolean(errors.translationId)}
            helperText={touched.translationId && errors.translationId}
            sx={{ mt: 2 }}
          >
            {translationKeys.map((t) => (
              <MenuItem key={t.id} value={t.id}>
                {t.translationKey}
              </MenuItem>
            ))}
          </TextField>

          <TextField
            name="translatedValue"
            label="Translated Value"
            value={values.translatedValue}
            onChange={handleChange}
            onBlur={handleBlur}
            fullWidth
            error={touched.translatedValue && Boolean(errors.translatedValue)}
            helperText={touched.translatedValue && errors.translatedValue}
            sx={{ mt: 2 }}
          />

          <Button type="submit" variant="contained" sx={{ mt: 2 }}>
            Save
          </Button>
        </Form>
      )}
    </Formik>
  );
};